import MuiTextField from "@Components/generic/mui-text-field";
import { Actions, AppContext, Events } from '@Context/common/general/context';
import { getAuthErrorMessage } from "@Helpers/utilities-ryan";
import useI18n from "@i18n";
import { Alert, Button, Collapse, Dialog, Stack, useTheme } from "@mui/material";
import Typography from '@mui/material/Typography';
import * as React from "react";
import { useEffect } from "react";
import { Parm0Callback } from "../app/members/teamInterfaces";

const SecurityCheckDialog = ({
    open,
    onClose = () => {},
    onConfirm = () => {},
    onCancel = () => {},
    onDismiss = () => {},
    onForgotPassword = () => {},
}: {
    open: boolean,
    onClose?: Parm0Callback,
    onConfirm?: Parm0Callback,
    onCancel?: Parm0Callback,
    onDismiss?: Parm0Callback,
    onForgotPassword?: Parm0Callback,
}) => {
    const { i18n } = useI18n();
    const { state, dispatch } = React.useContext(AppContext);

    const[ inputValue, setInputValue] = React.useState<string>("");
    const [errorMessage, setErrorMessage ] = React.useState<string>("");
    const [submissionAllowed, setSubmissionAllowed] = React.useState<boolean>(true);

    const theme: any = useTheme();

    useEffect(()=> {
        if(open === true) {
            setErrorMessage("");
            setSubmissionAllowed(true);
        }
    }, [open])

    const reauthenticate = (password: string) => {  // Todo - Replace with dedicated re-auth action to reset app state?

        setErrorMessage("");
        dispatch({
            type: Actions.FirebaseActions.Login,
            payload: {
                email: state.user.email,
                password
            },
            onSuccess: () => { onConfirm(); },
            onError: (error: any) => { 
                setErrorMessage(i18n(getAuthErrorMessage(error.code)));
            }
        })
    }

    const handleResetPassword = () => {
        onForgotPassword();
        onDismiss();
        Events.app.navigate.emit({ path: "/forgot-password" });
    }

    const showResetPasswordLink = !state.device.isMobile && !state.device.isUnityEmbedded;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: theme => `${theme.spacing(4)} ${theme.spacing(4)}`,
                    backgroundColor: theme.palette.dsSurface.v100
                },
            }}
        >
            <Stack spacing={2}>
                <Typography variant={"h5"}>
                    {i18n('security.check-dialog.title')}
                </Typography>
                {submissionAllowed && <Typography variant={"body1"}>
                    {i18n('security.check-dialog.description')}
                </Typography>}
                <Collapse in={(errorMessage != "")}>
                    <Alert severity="error">{errorMessage}</Alert>
                </Collapse>
                {submissionAllowed && <form autoComplete="off" 
                onSubmit={(e: React.FormEvent)=>{
                    e.preventDefault();
                    reauthenticate(inputValue);
                }}>
                    <MuiTextField
                        autoFocus
                        label={i18n('security.check-dialog.password-label')}
                        type="password"
                        autoComplete="off"
                        fullWidth
                        onChange={(event: React.ChangeEvent<any>) => {
                            setInputValue(event.target.value);
                        }}
                    />
                </form>}

                {submissionAllowed && showResetPasswordLink && (
                    <Stack direction="row" justifyContent="center">
                        <Typography variant="textS400" color="dsNeutral.v300">
                            {i18n("signin.forgot.password.ingress")}{" "}
                            <Typography
                                component="span"
                                variant="textSUnderline"
                                color="dsPrimary.v300"
                                onClick={handleResetPassword}
                                sx={{
                                    cursor: "pointer",
                                }}
                            >
                                {i18n("signin.forgot.password.link")}
                            </Typography>
                        </Typography>
                    </Stack>
                )}

                <Stack spacing={2} direction='row' paddingTop={theme.spacing(2)} justifyContent='center'>
                    {submissionAllowed && <Button color="primary" variant="contained" autoFocus onClick={() => { reauthenticate(inputValue); }} >
                        {i18n('continue')}
                    </Button>}
                    <Button color="primary" variant="text" onClick={onCancel}>
                        {i18n('cancel')}
                    </Button>
                </Stack>
            </Stack>
        </Dialog>
    );
};

export default SecurityCheckDialog;
